@if (categorizedData[step]?.isComplete) {
  <div
    class="step__logo green-svg"
    [matTooltip]="
      !categorizedData[step]?.previousStepCompleted
        ? 'Pour continuer, vous devez terminer toutes les étapes précédentes.'
        : categorizedData[step]?.isComplete
          ? 'étape complétée'
          : 'Cette étape n\'est pas encore terminée'
    "
    matTooltipPosition="right"
    [matTooltipClass]="'mat-tooltip'"
  >
    @if (step !== 'Signature') {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
      >
        <path
          d="M14.3244 1.65234L5.62848 10.3483L1.67578 6.39559"
          stroke="white"
          stroke-width="1.58108"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
    @if (step == 'Signature') {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="11"
        viewBox="0 0 12 11"
        fill="none"
      >
        <path
          d="M0.918945 8.90519C0.918945 8.90519 1.55408 8.27006 3.45949 8.27006C5.36489 8.27006 6.63516 9.54033 8.54057 9.54033C10.446 9.54033 11.0811 8.90519 11.0811 8.90519V1.28357C11.0811 1.28357 10.446 1.91871 8.54057 1.91871C6.63516 1.91871 5.36489 0.648438 3.45949 0.648438C1.55408 0.648438 0.918945 1.28357 0.918945 1.28357V8.90519Z"
          stroke="white"
          stroke-width="1.27027"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
  </div>
}

@if (!categorizedData[step]?.isComplete && step != category) {
  <div
    class="step__logo empty-svg"
    [matTooltip]="
      !categorizedData[step]?.previousStepCompleted
        ? 'Pour continuer, vous devez terminer toutes les étapes précédentes.'
        : categorizedData[step]?.isComplete
          ? 'étape complétée'
          : 'Cette étape n\'est pas encore terminée'
    "
    matTooltipPosition="right"
    [matTooltipClass]="'mat-tooltip'"
  >
    @if (step !== 'Signature') {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
      >
        <path
          d="M14.3244 1.65234L5.62848 10.3483L1.67578 6.39559"
          stroke="#01A341"
          stroke-width="1.58108"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
    @if (step == 'Signature') {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="11"
        viewBox="0 0 12 11"
        fill="none"
      >
        <path
          d="M0.918945 8.90519C0.918945 8.90519 1.55408 8.27006 3.45949 8.27006C5.36489 8.27006 6.63516 9.54033 8.54057 9.54033C10.446 9.54033 11.0811 8.90519 11.0811 8.90519V1.28357C11.0811 1.28357 10.446 1.91871 8.54057 1.91871C6.63516 1.91871 5.36489 0.648438 3.45949 0.648438C1.55408 0.648438 0.918945 1.28357 0.918945 1.28357V8.90519Z"
          stroke="#01A341"
          stroke-width="1.27027"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
  </div>
}

@if (!categorizedData[step]?.isComplete && step == category) {
  <div
    class="step__logo border"
    [matTooltip]="
      !categorizedData[step]?.previousStepCompleted
        ? 'Pour continuer, vous devez terminer toutes les étapes précédentes.'
        : categorizedData[step]?.isComplete
          ? 'étape complétée'
          : 'Cette étape n\'est pas encore terminée'
    "
    matTooltipPosition="right"
    [matTooltipClass]="'mat-tooltip'"
  >
    @if (step != 'Signature') {
      <i class="fa fa-duotone fa-hourglass-half"></i>
    }
    @if (step == 'Signature') {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="11"
        viewBox="0 0 12 11"
        fill="none"
      >
        <path
          d="M0.918945 8.90519C0.918945 8.90519 1.55408 8.27006 3.45949 8.27006C5.36489 8.27006 6.63516 9.54033 8.54057 9.54033C10.446 9.54033 11.0811 8.90519 11.0811 8.90519V1.28357C11.0811 1.28357 10.446 1.91871 8.54057 1.91871C6.63516 1.91871 5.36489 0.648438 3.45949 0.648438C1.55408 0.648438 0.918945 1.28357 0.918945 1.28357V8.90519Z"
          stroke="#01A341"
          stroke-width="1.27027"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
  </div>
}
